import { FC, useState } from 'react'

import { Icons, Text } from '@agro-club/agroclub-shared'

import { AButton } from 'views/components/Analytics'
import { CarStatuses, LogisticsKRCar } from 'views/pages/LogisticsKR/types'
import { DetailsItemButtons, DetailsItemInfo } from 'views/pages/LogisticsKR/components/styled'
import { Card } from 'views/components/Card/Card'
import styled from 'styled-components'
import { CarEditModal } from 'views/pages/LogisticsKR/CarsKR/CarEditModal/CarEditModal'
import { refetchFunc } from 'modules/domain/common/hooks'
import { ArchivedConfirmModal } from 'views/pages/LogisticsKR/components/PopoverContent/ArchivedConfirmModal'
import { ToActiveConfirmModal } from 'views/pages/LogisticsKR/components/PopoverContent/ToActiveConfirmModal'
import { useCarsParams } from './useCarsParams'
import { useTranslation } from 'react-i18next'
import { CarDocuments } from './CarDocuments'

interface Props {
  car: LogisticsKRCar
  refetch: refetchFunc
}

const SpaceBetween = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
`

export const CarItem: FC<Props> = ({ car, refetch }) => {
  const { t } = useTranslation('logisticsKR')
  const [isModalOpened, setIsModalOpened] = useState(false)
  const [archivedConfirmModal, setArchivedConfirmModal] = useState(false)
  const [toActiveConfirmModal, setToActiveConfirmModal] = useState(false)
  const info = useCarsParams(car)
  const isArchive = car.status === CarStatuses.archived

  return (
    <>
      <Card.Container style={{ minHeight: '140px' }}>
        <SpaceBetween>
          <Text color={isArchive ? 'tertiary' : undefined}>
            <DetailsItemInfo>
              {car.brand_model} {car.licence_number} {isArchive ? t('carriers.archived') : ''}
            </DetailsItemInfo>
            {info.carInfo} {info.extraInfo}
          </Text>
          <DetailsItemButtons>
            {car.status === CarStatuses.draft && (
              <AButton
                id="carToActive"
                color="secondary"
                background="none"
                Icon={Icons.IconCheck}
                onClick={() => setToActiveConfirmModal(true)}
              />
            )}
            {!isArchive && (
              <>
                <AButton
                  id="editCar"
                  color="secondary"
                  background="none"
                  Icon={Icons.IconEdit}
                  onClick={() => setIsModalOpened(true)}
                />
                <AButton
                  id="archiveCar"
                  color="secondary"
                  background="none"
                  Icon={Icons.IconDelete}
                  onClick={() => setArchivedConfirmModal(true)}
                />
              </>
            )}
          </DetailsItemButtons>
        </SpaceBetween>
        <CarDocuments carId={car.id} />
      </Card.Container>

      {isModalOpened && <CarEditModal car={car} onClose={() => setIsModalOpened(false)} onSuccess={refetch} />}
      {archivedConfirmModal && (
        <ArchivedConfirmModal car={car} onSuccess={refetch} onClose={() => setArchivedConfirmModal(false)} />
      )}
      {toActiveConfirmModal && (
        <ToActiveConfirmModal car={car} onSuccess={refetch} onClose={() => setToActiveConfirmModal(false)} />
      )}
    </>
  )
}
